import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import { PageListUrlDialog } from "../modeling/urls";
import { ActiveTab, BulkAction, Dialog, Pagination, SingleAction, Sort } from "../types";

export const learnDiscoverySection = "/learn-discover/";

export enum LearnDiscoverySection {
  markets = "markets",
  materials = "materials",
  reports = "reports",
  learning = "learning",
}

export enum MarketsTab {
  countryProfiles = "country-profiles",
  tradeAgreements = "trade-agreements",
  regions = "regions",
}

export enum MaterialsTab {
  materialGroups = "material-groups",
  materialItems = "material-items",
}

export enum ReportsTab {
  regionalReports = "regional-reports",
  companyDirectory = "company-directory",
}

export enum LearnDiscoveryListUrlFiltersEnum {
  query = "query",
  status = "status",
  region = "region",
  tag = "tag",
}

export enum LearnDiscoveryListUrlSortField {
  title = "title",
  slug = "slug",
  isPublished = "isPublished",
  sortOrder = "sort_order",
}

export type LearnDiscoveryListUrlFilters = Partial<
  Record<LearnDiscoveryListUrlFiltersEnum, string>
>;

export type LearnDiscoveryListUrlQueryParams = BulkAction &
  LearnDiscoveryListUrlFilters &
  Dialog<PageListUrlDialog> &
  Sort<LearnDiscoveryListUrlSortField> &
  Pagination &
  ActiveTab & {
    section?: LearnDiscoverySection;
    tab?: string;
  };

export const learnDiscoveryListPath = learnDiscoverySection;
export const learnDiscoveryListUrl = (params?: LearnDiscoveryListUrlQueryParams): string =>
  learnDiscoveryListPath + "?" + stringifyQs(params);

export const learnDiscoveryPath = (id: string): string =>
  urlJoin(learnDiscoverySection, "details", id);

export const learnDiscoveryCreatePath = urlJoin(learnDiscoverySection, "add");
export const learnDiscoveryCreateUrl = (
  params?: { "page-type-id"?: string } & LearnDiscoveryListUrlQueryParams,
): string => learnDiscoveryCreatePath + "?" + stringifyQs(params);

export type LearnDiscoveryUrlQueryParams = Dialog<
  "remove" | "assign-attribute-value" | PageListUrlDialog
> &
  SingleAction &
  LearnDiscoveryListUrlQueryParams;

export const learnDiscoveryUrl = (id: string, params?: LearnDiscoveryUrlQueryParams): string =>
  learnDiscoveryPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const learnDiscoverySettingsPath = urlJoin(learnDiscoverySection, "settings");
export const learnDiscoverySettingsUrl = learnDiscoverySettingsPath;
